"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var FontIcon_1 = __importDefault(require("../../icon/FontIcon"));
var date_fns_1 = require("date-fns");
var eventUtils_1 = require("../../common/eventUtils");
var Header = function (_a) {
    var date = _a.date, dir = _a.dir, labels = _a.labels, months = _a.months, onChange = _a.onChange, parentRef = _a.parentRef;
    var changeYear = function (amount) {
        onChange(date_fns_1.addYears(date, amount));
    };
    var changeMonth = function (amount) {
        onChange(date_fns_1.addMonths(date, amount));
    };
    /**
     * Change the behaviour of 'Tab' and 'Shift + Tab' event of an html element
     * Used to allow loop navigation "'Today Button' --> Header (<<) --> Header (<)"
     */
    var ajustLoopNavigation = function (event) {
        if (!parentRef) {
            return;
        }
        if (event.key === eventUtils_1.Keys.TAB) {
            eventUtils_1.cancelEvent(event);
            if (event.shiftKey) {
                var elClassPrevious = parentRef.querySelector('.tk-daypicker-today');
                if (elClassPrevious) {
                    elClassPrevious.focus();
                }
            }
            else {
                var elClassNext = parentRef.querySelector('.tk-daypicker-header--prevMonth');
                if (elClassNext) {
                    elClassNext.focus();
                }
            }
        }
    };
    var textHeader = months[date.getMonth()] + " " + date.getFullYear();
    return (React.createElement("div", { className: "tk-daypicker-header", role: "heading", style: { direction: dir } },
        React.createElement("div", null,
            React.createElement("button", { "aria-label": labels.previousYear, className: "tk-daypicker-header--prevYear", onClick: function () { return changeYear(-1); }, onKeyDown: ajustLoopNavigation },
                React.createElement(FontIcon_1.default, { iconName: dir === 'rtl' ? 'chevron-right' : 'chevron-left' })),
            React.createElement("button", { "aria-label": labels.previousMonth, className: "tk-daypicker-header--prevMonth", onClick: function () { return changeMonth(-1); } },
                React.createElement(FontIcon_1.default, { iconName: dir === 'rtl' ? 'right' : 'left' }))),
        React.createElement("div", { className: "tk-daypicker-header--text" }, textHeader),
        React.createElement("div", null,
            React.createElement("button", { "aria-label": labels.nextMonth, className: "tk-daypicker-header--nextMonth", onClick: function () { return changeMonth(1); } },
                React.createElement(FontIcon_1.default, { iconName: dir === 'rtl' ? 'left' : 'right' })),
            React.createElement("button", { "aria-label": labels.nextYear, className: "tk-daypicker-header--nextYear", onClick: function () { return changeYear(1); } },
                React.createElement(FontIcon_1.default, { iconName: dir === 'rtl' ? 'chevron-left' : 'chevron-right' })))));
};
Header.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    dir: PropTypes.oneOf(['rtl', 'ltr']).isRequired,
    labels: PropTypes.exact({
        nextMonth: PropTypes.string.isRequired,
        previousMonth: PropTypes.string.isRequired,
        previousYear: PropTypes.string.isRequired,
        nextYear: PropTypes.string.isRequired,
    }).isRequired,
    months: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func,
    parentRef: PropTypes.any,
};
exports.default = Header;
